import { useEffect } from 'react';

import { HomeInitialCapability } from '@/pages/home-page/state/constants';
import { useHomeData } from '@/pages/home-page/state/hooks';
import { THomeCapability } from '../../state/types';
import { HomePageCapabilitiesInfo } from './capabilities/home-page-capabilities-info';
import { HomePageCapabilitiesPicker } from './capabilities/home-page-capabilities-picker';
import { HomePageMissionInfo } from './home-page-mission-info';

const data: {
  title: string;
  capabilities: THomeCapability[];
} = {
  title: 'Redefining Secure Seamless Collaboration',
  capabilities: [
    {
      key: 'collaborative',
      title: 'Collaborative',
      position: [0, 1.15, 1.1],
      description: 'Automate workflows with confidential data. Universal. Onchain collaboration.'
    },
    {
      key: 'private',
      title: 'Private',
      position: [-1.6, 1, -0.05],
      description: 'Privacy built simply. No code. Plug & Play. Anywhere'
    },
    {
      key: 'selective',
      title: 'Selective',
      position: [1.3, 1.05, -0.9],
      description: 'Share only what you want. A security model tailored to your needs.'
    },
    {
      key: 'decentralized',
      title: 'Decentralized',
      position: [1.6, -1, 0.3],
      description: 'Public onchain infrastructure. Utility-based reward protocol mechanisms.'
    },
    {
      key: 'verifiable',
      title: 'Verifiable',
      position: [-1.1, -1.2, 1.3],
      description: 'Verify outcomes and interactions. Anything and anyone.'
    }
  ]
};

export const HomePageMission = () => {
  const { capability, setCapability } = useHomeData();
  const { title, capabilities } = data;

  const currentCapability = capabilities.find(({ key }) => key === capability);

  useEffect(() => {
    if (currentCapability) return;
    setCapability(HomeInitialCapability);
  }, [currentCapability, setCapability]);

  return (
    <div className="w-full grid grid-cols-1 lg:grid-cols-2 items-center gap-8 lg:gap-14 xl:gap-20">
      {/* Left column: title + sphere */}
      <div className="flex flex-col items-start gap-6 lg:gap-10">
        <HomePageMissionInfo title={title} />

        <HomePageCapabilitiesPicker
          items={capabilities}
          onChange={setCapability}
          value={capability}
        />
      </div>

      {/* Right column: capability label + description + hint */}
      <HomePageCapabilitiesInfo
        capabilityTitle={currentCapability?.title}
        description={currentCapability?.description}
      />
    </div>
  );
};
